import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';

import {CategoriesRoutingModule} from './categories-routing.module';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {CategoriesComponent} from './categories.component';
import {CategoriesRepository} from './repositories/categories.repository';
import {CategoriesService} from './services/categories.service';

@NgModule({
  imports: [
    CommonModule,
    CategoriesRoutingModule,
    SearchBarModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    FormsModule,
    ModalConfirmationModule,
  ],
  declarations: [
    CategoriesComponent,
  ],
  providers: [
    CategoriesService,
    CategoriesRepository,
  ],
})

export class CategoriesModule {}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/categories/categories.module.ts